module.exports = __webpack_public_path__ + "img/christmas-gallery-3.34d6db57.jpg";